module.exports = __webpack_public_path__ + "static/media/cover-product-5.84f6b084.jpg";